export default __webpack_public_path__ + "static/media/gs-4.486e9353.png";